module.exports = __webpack_public_path__ + "img/ai_interview_cover.80a9ad58.png";